/**
 * Builds WebSocket URLs from the deployment's configured socket host.
 *
 * Three call sites hardcoded the vendor's servers instead of reading any
 * configuration:
 *
 *   useChatSocket.ts          wss://demo.thecallcentral.com/ws/chat/?token=...
 *   useCalendarWebSocet.ts    wss://demo.thecallcentral.com/ws/calendar/?token=...
 *   StatusBoardSocketService  wss://thecallcentral.com/api/v1/
 *
 * The first two put a valid user auth token in a URL sent to a third party on
 * every visit to Schedule and Messages. All three now resolve against
 * REACT_APP_WEB_SOCKETURL.
 *
 * Paths must keep their trailing slash: the server routes are anchored
 * (^ws/chat/$), so "ws/chat" would not match.
 */

const DEFAULT_BASE = "ws://localhost:8019/";

export const socketBaseUrl = (): string => {
  const configured = (window as any)._env_?.REACT_APP_WEB_SOCKETURL;
  const base: string = configured || DEFAULT_BASE;
  return base.endsWith("/") ? base : `${base}/`;
};

/**
 * @param path  server-relative socket path, e.g. "ws/chat/"
 * @param token decoded auth token; omitted when the socket needs no auth
 */
export const socketUrl = (path: string, token?: string): string => {
  const url = `${socketBaseUrl()}${path.replace(/^\/+/, "")}`;
  return token ? `${url}?token=${encodeURIComponent(token)}` : url;
};

/** The stored token is base64; every socket needs it decoded. */
export const decodedAuthToken = (): string => {
  try {
    const raw = localStorage.getItem("token");
    return raw ? atob(raw) : "";
  } catch (e) {
    return "";
  }
};
